._copyBtn_1iiqb_1 .ant-typography {
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
}